
import { mapGetters } from 'vuex'
import Flow from './Flow.vue'
import { encrypt, decrypt } from '@/utils/secret'

export default {
    components: {
        Flow
    },
    props: {},
    computed: {
        ...mapGetters({
            orderImGoods: 'ry/orderImGoods',
            workOrderCardData: 'ry/workOrderCardData',
            newNodeCard: 'ry/newNodeCard',
            userinfo: 'user/userinfo'
        })
    },
    methods: {
        // 工单逻辑按钮
        workOrderClick (item, items, index) {
            switch (items.strategy) {
            case 'NEXT_CARD':
            case 'NEXT_NODE':
            case 'AWAKE_CS':
                if (items.doubleConfirmation) {
                    this.$confirm('本卡片为交易重点环节，请仔细确认卡片内交易操作是否完成，若未完成请点击取消，有疑问请及时@客服协助处理！', '二次确认', {
                        confirmButtonText: '确认完成',
                        confirmButtonClass: 'confirmButtonClass',
                        dangerouslyUseHTMLString: true
                    }).then(() => {
                        this.onNextStep(item, index)
                    })
                    return
                }
                this.onNextStep(item, index)
                break
            case 'JUMP_LINK':
                if (items.url && items.url.includes('/details/')) {
                    const _urlReplace = '/details/'
                    const _url = items.url.replace(new RegExp(`^.*?${_urlReplace}`), '')
                    window.open(`${location.origin}/helpCenter/${_url}`)
                } else {
                    window.open(items.url)
                }
                break
            case 'SUBMIT':
                this.getFormComp(item, index)
                break
            case 'PAY':
                this.$parent.getPayOrder(item)
            default:
                break
            }
        },
        onNextStep (item, index) {
            const data = {
                buttonIndex: index,
                buttonStrategy: item.buttonVOList[index].strategy,
                idToken: item.buttonVOList[index].idToken,
                formDataActionList: undefined,
                nodeId: item.nodeId,
                cardId: item.id,
                orderId: item.orderId,
                type: item.type
            }
            this.$api.workorderCardButtonSubmit(data).then(res => {
                if (res.success) {
                    this.$message.success('操作成功')
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        getFormComp (item, index) {
            let formData = {}
            switch (item.type) {
            // 取消交易，买家提供收款账号
            case 'CANCEL_DEAL_BUYER_RECEIVABLES_ACCOUNT':
                if (item.content.permissions == this.userinfo.id) {
                    this.$api.getReceiverAccountApi({ orderId: item.content.orderId }).then(res => {
                        if (!res.success) {
                            return this.$message.error(res.info)
                        }

                        if (res.data.isSingleAccount || res.data.isSingleAccount === null) {
                            formData = {
                                buttonIndex: index,
                                buttonStrategy: item.content.buttons[index].strategy,
                                idToken: item.content.buttons[index].idToken,
                                nodeId: item.content.nodeId,
                                cardId: item.content.cardId,
                                orderId: item.content.orderId,
                                type: item.content.type,
                                title: item.content.title,
                                isBuy: 1,
                                ...res.data
                            }
                            this.$parent.regularFrom(formData, item)
                        } else {
                            this.$message.warning('当前订单为多账户收款订单，请联系客服处理！')
                        }
                    })
                } else {
                    this.$message.error('无权查看')
                }
                break
            case 'SELLER_COLLECTION_ACCOUNT_NUMBER':
                //  卖家收款账号校验
                if (item.permissions == this.userinfo.id) {
                    formData = {
                        buttonIndex: index,
                        buttonStrategy: item.buttonVOList[index].strategy,
                        idToken: item.buttonVOList[index].idToken,
                        nodeId: item.nodeId,
                        cardId: item.id,
                        orderId: item.orderId,
                        type: item.type,
                        title: item.title,
                        isBuy: 2
                    }
                    this.$parent.regularFrom(formData, item)
                } else {
                    this.$message.error('无权查看')
                }
                break
            case 'SELLER_COLLECTION_ACCOUNT_ERROR':
                //  账户异常重新提交
                if (item.permissions == this.userinfo.id) {
                    formData = {
                        buttonIndex: index,
                        buttonStrategy: item.buttonVOList[index].strategy,
                        idToken: item.buttonVOList[index].idToken,
                        nodeId: item.nodeId,
                        cardId: item.id,
                        orderId: item.orderId,
                        type: item.type,
                        title: item.title,
                        isBuy: 3
                    }
                    this.$parent.regularFrom(formData, item)
                } else {
                    this.$message.error('无权查看')
                }
                break
            case 'BUYER_COLLECTION_ACCOUNT_ERROR':
                //  账户异常重新提交
                if (item.content.permissions == this.userinfo.id) {
                    this.$api.getReceiverAccountApi({ orderId: item.content.orderId }).then(res => {
                        if (!res.success) {
                            return this.$message.error(res.info)
                        }
                        if (res.data.isSingleAccount || res.data.isSingleAccount === null) {
                            formData = {
                                buttonIndex: index,
                                buttonStrategy: item.content.buttons[index].strategy,
                                idToken: item.content.buttons[index].idToken,
                                nodeId: item.content.nodeId,
                                cardId: item.content.cardId,
                                orderId: item.content.orderId,
                                type: item.content.type,
                                title: item.content.title,
                                isBuy: 4,
                                ...res.data
                            }
                            this.$parent.regularFrom(formData, item)
                        } else {
                            this.$message.warning('当前订单为多账户收款订单，请联系客服处理！')
                        }
                    })
                } else {
                    this.$message.error('无权查看')
                }
                break
            default:
                // 动态表单
                if (item.permissions == this.userinfo.id) {
                    const data = {
                        buttonIndex: index,
                        cardId: item.id,
                        nodeId: item.nodeId,
                        orderId: item.orderId
                    }
                    this.$api.workorderCardFormData(data).then(res => {
                        if (res.success) {
                            const _arr = []
                            res.data.formDataFiledVOList.map((v, i) => {
                                _arr.push({
                                    ...v,
                                    cardButtonSubmit: v.dataType
                                })
                            })
                            formData = {
                                formDataActionList: _arr,
                                warning: res.data.warning,
                                buttonIndex: index,
                                buttonStrategy: item.buttonVOList[index].strategy,
                                idToken: item.buttonVOList[index].idToken,
                                nodeId: item.nodeId,
                                cardId: item.id,
                                orderId: item.orderId,
                                type: item.type,
                                title: item.title
                            }
                            this.$parent.getFormComp(formData)
                        } else {
                            this.$message.error(res.info)
                        }
                    })
                } else {
                    this.$message.error('无权查看')
                }
                break
            }
        },
        gotoUrl (item) {
            if (item && item.includes('/details/')) {
                const _urlReplace = '/details/'
                const _url = item.replace(new RegExp(`^.*?${_urlReplace}`), '')
                window.open(`${location.origin}/helpCenter/${_url}`)
            } else {
                window.open(item)
            }
        },
        // 处理密码加密解密
        getPdwValue (val) {
            let data = val.value
            if (val.fieldType == 'PASSWORD') {
                data = decrypt(val.value)
            }
            if (val.fieldType == 'ACCOUNT') {
                data = decrypt(val.value)
            }
            return data
        }
    }
}
